import styled from "styled-components";

import PButton from "../../../../components/PButton";

export const Container = styled.div`
  display: flex;
  flex: 1;
`;

export const TitleWrap = styled.div`
  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  @media only screen and (max-width: 560px) {
    padding-top: 30px;
  }
`;

export const TitleFirst = styled.div`
  position: relative;
  width: fit-content;
`;

export const TitleSecond = styled.div`
  position: relative;
  width: fit-content;
`;

export const TitleText = styled.div`
  font-family: "Lora Medium";
  font-size: 40px;
  color: ${({ theme }) => theme.colors.blackGreen};
  margin-top: -44px;
  padding-left: 6px;
  padding-right: 12px;

  @media only screen and (max-width: 768px) {
    font-size: 40px;
  }
  @media only screen and (max-width: 560px) {
    font-size: 27px;
  }
`;

export const BgColorDiv = styled.div`
  height: 20px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.lightGray2};

  @media only screen and (max-width: 768px) {
    height: 20px;
    margin-bottom: 0px;
  }
  @media only screen and (max-width: 560px) {
    height: 20px;
    margin-bottom: 10px;
  }
`;

export const SummaryContainer = styled.div`
  ${({ theme }) => theme.textStyles.content2}
  font-family: "Helvetica";
  padding-left: 10px;
  padding-right: 100px;
  padding-top: 40px;
  padding-bottom: 40px;

  @media only screen and (max-width: 768px) {
    padding-top: 30px;
    padding-right: 10px;
    font-size: 14px;
  }
`;

export const ButtonWrap = styled.div`
  margin-left: 10px;

  @media only screen and (max-width: 768px) {
    padding-left: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 60px;
  }
`;

export const MoreButton = styled(PButton)`
  padding-left: ${({ theme }) => theme.spacings.spacing_xxl_m};
  padding-right: ${({ theme }) => theme.spacings.spacing_xxl_m};
  border-radius: 0;
  border-color: ${({ theme }) => theme.colors.primary};
  & span {
    font-size: 14px;
  }

  @media only screen and (max-width: 768px) {
    height: 60px;
    & span {
      font-size: 16px;
    }
  }

  @media only screen and (max-width: 560px) {
    height: 46px;
    & span {
      font-size: 14px;
    }
  }
`;
